<template>
  <div class="dynamic-line-container">
    <div class="title">
      <div>
        <el-col v-for="(item, index) in lineTitle" :key="'title' + index" :span="Math.floor(24 / lineTitle.length)">{{ item }}</el-col>
      </div>
    </div>
    <div class="content">
      <el-row v-for="(item, index) in list" :key="'list' + index" :gutter="12">
        <el-col v-for="(item2, index2) in lineTitle" :key="'item' + index2" :span="Math.floor(24 / lineTitle.length)"><el-input v-model.trim="list[index].index2" :placeholder="'请输入' + item2" /></el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Array,
      default: () => []
    },
    lineTitle: {
      type: Array,
      default: () => ['标题1', '标题2', '标题3']
    }
  },
  data() {
    return {
      list: [[]]
    }
  },
  watch: {
    lineTitle(val) {
      this.list[0] = []
      val.forEach(() => {
        this.list[0].push('')
      })
    }
  },
  created() {},
  mounted() {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.dynamic-line-container {
  .title {
    border-radius: 4px;
    .el-col {
      background: #f3f3f3;
      border-radius: 4px;
      margin-bottom: 10px;
      padding-left: 6px;
    }
  }
  .content {
    padding-top: 10px;
    >div {
      margin-bottom: 10px;
    }
  }
}
</style>
